import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f40c5dba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "form-field"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Gate Key", -1))
const _hoisted_7 = {
  key: 1,
  class: "form-field"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Tenant Protection", -1))
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "No Plan", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 2,
  class: "form-field"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Insurance Plans", -1))
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "No Plan", -1))
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 3,
  class: "form-field"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Cancel Plan", -1))
const _hoisted_19 = { class: "form-field" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Self Insured Policy Acknowledged At", -1))
const _hoisted_21 = { class: "form-field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Self Insured Policy Expires On", -1))
const _hoisted_23 = {
  key: 4,
  class: "form-field"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Self Insured Policy Description", -1))
const _hoisted_25 = { class: "form-field" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Self Insured Policy Number", -1))
const _hoisted_27 = {
  key: 5,
  class: "form-field"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Self Insured Policy Provider", -1))
const _hoisted_29 = {
  key: 6,
  class: "form-field"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Self Insured Policy Coverage", -1))
const _hoisted_31 = {
  key: 7,
  class: "form-field"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " Cancel Self Insured Policy", -1))
const _hoisted_33 = { class: "form-field" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Move-in Date", -1))
const _hoisted_35 = {
  key: 0,
  class: "form-field"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Tax rate (%)", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "No Tax", -1))
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "form-field" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "col"
}
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Updating Unit ")
const _hoisted_43 = {
  key: 1,
  class: "col"
}

import { ref, watch, onMounted } from "vue";
import moment from "moment";
import BaseSpinner from "@/components/BaseSpinner.vue";

import api from "@virgodev/bazaar/functions/api";
import { TenantProtectionPlanInterface } from "@/types/unit";
import { RentalInterface } from "@/types/customers";

import { useRouter } from "vue-router";

import { storeToRefs } from "pinia";
import { useStore } from "@/store";

export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: String,
    required: false,
    default: null,
  },
  rentalId: {
    type: String,
    required: false,
    default: null,
  },
  unitType: {
    type: String,
    required: false,
    default: null,
  },
  facilityId: {
    type: String,
    default: null,
  },
  facilityName: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

const status = ref("loading");

const errors = ref("");
const formSubmitting = ref(false);
const tenantProtectionPlans = ref(Array<TenantProtectionPlanInterface>());
const tenantProtectionPlan = ref();
const insurancePlan = ref();
// const cancelInsurance = ref(false);
const cancelPlan = ref(false);
const router = useRouter();

const store = useStore();
const { userData } = storeToRefs(store);
const api_settings = userData.value.chosenFacility.api_settings;

const taxRates = ref();
const unitTypeDetail = ref();
const formErrors = ref<Record<string, string[]>>({});
const formFields = ref({
  creator_id: ref(""), //rental from customer
  customer_id: props.customerId ? Number(props.customerId) : null,
  move_in_on: moment().format("YYYY-MM-DD"),
  available_promotion_id: ref(),
  unit_type_id: "",
  additional_deposit: "",
  amount_rented_for: ref(""),
  available_tenant_protection_plan_id: "",
  billing_cycle: ref(1),
  charge_additional_deposit: "",
  charge_deposit: ref(true),
  charge_setup_fee: ref(true),
  deposit: "",
  discount_as_percentage: "",
  exempt_from_rate_management: ref(false),
  agreement_delivery_methods: ref(["email", "text"]),
  insurance_plan_id: "",
  cancel: ref(),
  ledger_id: ref(),
  date: ref(),
  tenant_id: ref(),
  current_insurance: ref({ amount: ref(), description: ref() }),
  mark_additional_deposit_as_paid: "",
  mark_deposit_as_paid: "",
  plan_id: "",
  prorated_amount: "",
  prorated_insurance_premium: "",
  prorating: "none",
  rented_on: moment().format("YYYY-MM-DD"),
  setup_fee: ref(),
  setup_fee_tax_rate_id: "",
  tax_rate_id: "",
  unit_id: "",
  tenant_protection_plan_id: "",
  insurance_policy_id: "",
  self_insured_policy_acknowledged_at: "",
  self_insured_policy_expires_on: "",
  self_insured_policy_number: "",
  self_insured_policy_provider: "",
  self_insured_policy_coverage: "",
  self_insured_description: "",
});

// Keep customer_id in sync when props.customerId resolves
watch(
  () => props.customerId,
  (val) => {
    const id = val ? Number(val) : null;
    formFields.value.customer_id =
      id !== null && Number.isInteger(id) && id > 0 ? id : null;
  },
  { immediate: true }
);

const selfInsuredCancel = ref(false);
const ledgerId = ref();
const customer = ref();
const insurancePlans = ref();
const rentalDetails = ref();
const facility = ref();
onMounted(async () => {
  await getFacility();
  if (props.customerId) {
    await getCustomer();
    if (!api_settings.only_insurance_or_proof_option && facility.value) {
      if (
        facility.value.enabled_rental_coverage_signup_type ==
        "tenant_protection"
      ) {
        await getProtectionPlans();
      } else if (
        facility.value.enabled_rental_coverage_signup_type == "insurance"
      ) {
        await getInsurances();
      }
    } else {
      await getInsurances();
    }

    await getRental();
    getUnitTypes();
  }

  status.value = "completed";
});
async function getFacility() {
  if (!api_settings.only_insurance_or_proof_option) {
    errors.value = "";
    const response = await api({
      url: `facility/?facilityId=${props.facilityId}`,
    });
    if (response.status == 200) {
      facility.value = response.body;
    } else {
      errors.value =
        "Unable to communicate with the server. Please check your " +
        "connection and try again.";
    }
  }
}
async function getProtectionPlans() {
  errors.value = "";
  const response = await api({
    url: `available_tenant_protection_plans/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    tenantProtectionPlans.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getInsurances() {
  errors.value = "";
  const response = await api({
    url: `insurances/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    insurancePlans.value = response.body;
    // formFields.value.insurance_plan_id = insurancePlans.value[0].id;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function updateKey() {
  errors.value = "";
  const response = await api({
    url: `units/?id=${rentalDetails.value.id}&facilityId=${props.facilityId}`,
    method: "PUT",
    json: JSON.parse(
      JSON.stringify({
        name: rentalDetails.value.name,
        unit_type_id: rentalDetails.value.unit_type_id,
        gate_key: rentalDetails.value.gate_key,
      })
    ),
  });
  if (response.status != 200) {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getProtectionPlan() {
  errors.value = "";
  const response = await api({
    url: `tenant_protection_plans/?facilityId=${props.facilityId}&id=${formFields.value.tenant_protection_plan_id}`,
  });
  if (response.status == 200) {
    tenantProtectionPlan.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getInsurance() {
  errors.value = "";
  const response = await api({
    url: `insurance_policies/?facilityId=${props.facilityId}&id=${formFields.value.insurance_policy_id}`,
  });
  if (response.status == 200) {
    insurancePlan.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

async function getCustomer() {
  errors.value = "";
  const response = await api({
    url: `customers/?id=${props.customerId}&facilityId=${
      props.facilityId
    }&single=${true}`,
  });
  if (response.status == 200) {
    customer.value = response.body;
    if (response.body.length) {
      customer.value = response.body[0];
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

async function getRental() {
  if (api_settings.rental_shows_insurance) {
    let rental = customer.value.rentals.filter(
      (item: { id: string }) => item.id == props.rentalId
    )[0];
    rentalDetails.value = rental;
    if (rental.current_insurance && rental.current_insurance.description) {
      formFields.value.current_insurance = rental.current_insurance;
      insurancePlans.value.push({
        id: "custom",
        amount: formFields.value.current_insurance.amount,
        description: formFields.value.current_insurance.description,
      });
      formFields.value.insurance_plan_id = "custom";
      formFields.value.insurance_policy_id = "custom";
      insurancePlan.value = rental.current_insurance;
    } else if (rental.self_insured_policy_number) {
      formFields.value.self_insured_policy_expires_on =
        rental.self_insured_policy_expires_on;
      formFields.value.self_insured_policy_number =
        rental.self_insured_policy_number;
    }
  } else {
    errors.value = "";
    let url = `rentals/?id=${props.rentalId}&single=${true}&facilityId=${
      props.facilityId
    }`;
    if (
      api_settings.only_insurance_or_proof_option ||
      api_settings.allow_insurance_change
    ) {
      url = `ledgers/?id=${props.customerId}&facilityId=${props.facilityId}&lease_id=${props.rentalId}`;
    }
    const response = await api({
      url: url,
    });
    if (response.status == 200) {
      if (api_settings.only_insurance_or_proof_option) {
        response.body = response.body.filter(
          (item: { id: string }) => item.id == props.rentalId
        )[0];
        ledgerId.value = response.body.id;
      }
      formFields.value = response.body;
      if (response.body.length) {
        formFields.value = response.body[0];
      }
      if (formFields.value.tenant_protection_plan_id) {
        await getProtectionPlan();
        let selectedPlan = tenantProtectionPlans.value.filter(
          (item: { limit: string; fee: string }) =>
            item.limit == tenantProtectionPlan.value.limit &&
            item.fee == tenantProtectionPlan.value.fee
        );
        let chosenPlan = "";
        if (!selectedPlan.length) {
          tenantProtectionPlans.value.push({
            id: tenantProtectionPlan.value.id,
            limit: tenantProtectionPlan.value.limit,
            fee: tenantProtectionPlan.value.fee,
          });
          chosenPlan = tenantProtectionPlan.value.id;
        } else {
          chosenPlan = selectedPlan[0].id;
        }
        formFields.value.available_tenant_protection_plan_id = chosenPlan;
      } else if (
        formFields.value.insurance_policy_id ||
        formFields.value.current_insurance
      ) {
        if (!formFields.value.current_insurance) {
          await getInsurance();
          formFields.value.insurance_plan_id = insurancePlans.value.filter(
            (item: { limit: string; premium: string }) =>
              item.limit == insurancePlan.value.limit &&
              item.premium == insurancePlan.value.premium
          )[0].id;
        } else {
          let insurance_info = insurancePlans.value.filter(
            (item: { amount: string }) =>
              item.amount == formFields.value.current_insurance.amount
          );
          if (!insurance_info.length) {
            insurancePlans.value.push({
              id: 0,
              amount: formFields.value.current_insurance.amount,
              description: formFields.value.current_insurance.description,
            });
            insurance_info = 0;
          } else {
            insurance_info = insurance_info[0].id;
          }
          formFields.value.insurance_plan_id = insurance_info;
        }
      }
      if (api_settings.extra_rental_info) {
        rentalDetails.value = await getUnitDetails(response.body);
      }
    } else {
      errors.value =
        "Unable to communicate with the server. Please check your " +
        "connection and try again.";
    }
  }
}

async function getUnitDetails(rental: RentalInterface) {
  errors.value = "";
  if (!rental.unit_id) {
    rental.unit_id = Number(rental.id);
  }
  const response = await api({
    url: `units/?id=${rental.unit_id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    if (response.body.length > 0) {
      return response.body[0];
    }
    return response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
  return null;
}

async function getTaxRates() {
  errors.value = "";
  const response = await api({
    url: `tax_rates/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    taxRates.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getUnitTypes() {
  errors.value = "";
  const response = await api({
    url: `unit_types/?id=${props.unitType}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    unitTypeDetail.value = response.body;
    if (!api_settings.only_insurance_or_proof_option) {
      await getTaxRates();
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function submitForm() {
  const json = JSON.parse(JSON.stringify(formFields.value));
  formErrors.value = {};
  formSubmitting.value = true;
  if (!api_settings.self_insured_coverage_input) {
    delete json.self_insured_policy_coverage;
  }
  if (!api_settings.self_insured_description) {
    delete json.self_insured_description;
  }
  if (json.current_insurance && !json.current_insurance.description) {
    delete json.current_insurance.description;
  }

  let responseData;
  if (!api_settings.only_insurance_or_proof_option) {
    let url = `create_rental/?id=${props.rentalId}&facilityId=${props.facilityId}`;

    responseData = await api({
      url,
      method: "PUT",
      json,
    });
  }

  formSubmitting.value = false;
  if (
    (responseData && responseData.status === 200) ||
    api_settings.only_insurance_or_proof_option
  ) {
    let currentDay = moment().format("DD");
    let daysInMonth = moment().daysInMonth();
    let daysLeft = Number(daysInMonth) - Number(currentDay) + 1;
    let proratedAmount;
    if (
      !formFields.value.tenant_protection_plan_id &&
      formFields.value.available_tenant_protection_plan_id
    ) {
      let url = `tenant_protection_plans/?facilityId=${props.facilityId}`;
      proratedAmount =
        Number(
          tenantProtectionPlans.value.filter(
            (item: TenantProtectionPlanInterface) =>
              item.id == formFields.value.available_tenant_protection_plan_id
          )[0].fee
        ) / daysInMonth;
      proratedAmount = proratedAmount * daysLeft;
      const response = await api({
        url: url,
        method: "POST",
        json: {
          available_tenant_protection_plan_id:
            formFields.value.available_tenant_protection_plan_id,
          rental_id: props.rentalId,
          prorated_fee: proratedAmount,
        },
      });
      if (response.status == 200) {
        let name = "customer_detail_ess";
        if (
          api_settings.only_insurance_or_proof_option ||
          api_settings.allow_insurance_change
        ) {
          name = "customer_detail_storedge";
        }
        router.push({
          name: name,
          params: {
            id: props.customerId,
            facilityId: props.facilityId,
          },
        });
      }
    } else if (tenantProtectionPlan.value && cancelPlan.value) {
      let url = `tenant_protection_plans/?facilityId=${props.facilityId}&id=${formFields.value.tenant_protection_plan_id}`;
      await api({
        url: url,
        method: "DELETE",
      });
    } else if (insurancePlan.value && cancelPlan.value) {
      let url = `insurance_policies/?facilityId=${props.facilityId}&id=${formFields.value.insurance_policy_id}&ledgerId=${rentalDetails.value.id}`;
      await api({
        url: url,
        method: "DELETE",
      });
    } else if (
      (!formFields.value.insurance_policy_id &&
        formFields.value.insurance_plan_id) ||
      api_settings.only_insurance_or_proof_option
    ) {
      let url = `insurance_policies/?facilityId=${props.facilityId}`;
      let json = {};
      if (formFields.value.insurance_plan_id) {
        proratedAmount =
          Number(
            insurancePlans.value.filter(
              (item: { id: string }) =>
                item.id == formFields.value.insurance_plan_id
            )[0].premium
          ) / daysInMonth;
        proratedAmount = proratedAmount * daysLeft;
        json = {
          insurance_plan_id: formFields.value.insurance_plan_id,
          rental_id: props.rentalId,
          initial_amount: proratedAmount,
        };
      }

      if (api_settings.only_insurance_or_proof_option) {
        formFields.value.tenant_id = props.customerId;
        formFields.value.unit_id = rentalDetails.value.id;
        formFields.value.date = moment().format("YYYY-MM-DDTHH:mm:ss");
        formFields.value.ledger_id = ledgerId.value;
        formFields.value.cancel = selfInsuredCancel.value;
        json = JSON.parse(JSON.stringify(formFields.value));
        if (formFields.value.self_insured_policy_number) {
          url += `&type=proof`;
        }
      }
      const response_insurance = await api({
        url: url,
        method: "POST",
        json: json,
      });
      if (response_insurance.status == 200) {
        let name = "customer_detail_ess";

        if (
          api_settings.only_insurance_or_proof_option ||
          api_settings.allow_insurance_change
        ) {
          name = "customer_detail_storedge";
        }
        router.push({
          name: name,
          params: {
            id: props.customerId,
            facilityId: props.facilityId,
          },
        });
      }
    }
    let name = "customer_detail_ess";
    if (
      api_settings.only_insurance_or_proof_option ||
      api_settings.allow_insurance_change
    ) {
      name = "customer_detail_storedge";
    }
    router.push({
      name: name,
      params: {
        id: props.customerId,
        facilityId: props.facilityId,
      },
    });
  } else if (responseData && responseData.status === 400) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (responseData.body) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      formErrors.value = responseData.body;
    }
  } else {
    formErrors.value = {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      non_field_errors: responseData.body.errors,
    };
  }
  if (api_settings.update_gate_access_code) {
    updateKey();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.customerId && customer.value)
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 0,
          to: {
      name:
        _unref(api_settings).only_insurance_or_proof_option ||
        _unref(api_settings).allow_insurance_change
          ? 'customer_detail_storedge'
          : 'customer_detail_ess',
      params: { id: __props.customerId, facilityId: __props.facilityId },
    }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Back to Customer: " + _toDisplayString(customer.value.name), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    (rentalDetails.value)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "Edit Rental with " + _toDisplayString(rentalDetails.value.name), 1))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      class: "large-width-centered",
      onSubmit: _withModifiers(submitForm, ["prevent"])
    }, [
      (__props.unitType)
        ? (_openBlock(), _createElementBlock("fieldset", _hoisted_3, [
            (status.value === 'loading')
              ? (_openBlock(), _createBlock(BaseSpinner, {
                  key: 0,
                  preset: "large"
                }))
              : _createCommentVNode("", true),
            (status.value == 'completed')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_unref(api_settings).update_gate_access_code && rentalDetails.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _hoisted_6,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rentalDetails.value.gate_key) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, rentalDetails.value.gate_key]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
            tenantProtectionPlans.value &&
            !_unref(api_settings).only_insurance_or_proof_option
          )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _hoisted_8,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFields.value.available_tenant_protection_plan_id) = $event)),
                          class: "form-select",
                          disabled: tenantProtectionPlan.value
                        }, [
                          _hoisted_10,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tenantProtectionPlans.value, (plan) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: plan.id + 'plan',
                              value: plan.id
                            }, " $" + _toDisplayString(plan.limit) + " protection for $" + _toDisplayString(plan.fee) + " per month ", 9, _hoisted_11))
                          }), 128))
                        ], 8, _hoisted_9), [
                          [_vModelSelect, formFields.value.available_tenant_protection_plan_id]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (insurancePlans.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _hoisted_13,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formFields.value.insurance_plan_id) = $event)),
                          class: "form-select",
                          disabled: 
              (insurancePlan.value && !_unref(api_settings).allow_insurance_change) ||
              (formFields.value.current_insurance &&
                !_unref(api_settings).allow_insurance_change)
            
                        }, [
                          _hoisted_15,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(insurancePlans.value, (plan) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: plan.id + 'plan',
                              value: plan.id
                            }, _toDisplayString(plan.summary || plan.description), 9, _hoisted_16))
                          }), 128))
                        ], 8, _hoisted_14), [
                          [_vModelSelect, formFields.value.insurance_plan_id]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (tenantProtectionPlan.value || insurancePlan.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((cancelPlan).value = $event)),
                          type: "checkbox",
                          class: "form-check-input"
                        }, null, 512), [
                          [_vModelCheckbox, cancelPlan.value]
                        ]),
                        _hoisted_18
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formFields.value.self_insured_policy_acknowledged_at) = $event)),
                      type: "date"
                    }, null, 512), [
                      [_vModelText, formFields.value.self_insured_policy_acknowledged_at]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formFields.value.self_insured_policy_expires_on) = $event)),
                      type: "date"
                    }, null, 512), [
                      [_vModelText, formFields.value.self_insured_policy_expires_on]
                    ])
                  ]),
                  (_unref(api_settings).self_insured_description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _hoisted_24,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formFields.value.self_insured_description) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, formFields.value.self_insured_description]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formFields.value.self_insured_policy_number) = $event)),
                      type: "text"
                    }, null, 512), [
                      [_vModelText, formFields.value.self_insured_policy_number]
                    ])
                  ]),
                  (_unref(api_settings).self_insured_provider_input)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _hoisted_28,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formFields.value.self_insured_policy_provider) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, formFields.value.self_insured_policy_provider]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(api_settings).self_insured_coverage_input)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _hoisted_30,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formFields.value.self_insured_policy_coverage) = $event)),
                          type: "number",
                          step: ".01"
                        }, null, 512), [
                          [_vModelText, formFields.value.self_insured_policy_coverage]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
            _unref(api_settings).self_insured_cancel_input &&
            formFields.value.self_insured_policy_number
          )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selfInsuredCancel).value = $event)),
                          type: "checkbox",
                          class: "form-check-input"
                        }, null, 512), [
                          [_vModelCheckbox, selfInsuredCancel.value]
                        ]),
                        _hoisted_32
                      ]))
                    : _createCommentVNode("", true),
                  (!_unref(api_settings).only_insurance_or_proof_option)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formFields.value.move_in_on) = $event)),
                            type: "date",
                            required: ""
                          }, null, 512), [
                            [_vModelText, formFields.value.move_in_on]
                          ])
                        ]),
                        (taxRates.value && taxRates.value.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                              _hoisted_36,
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formFields.value.tax_rate_id) = $event)),
                                class: "form-select",
                                required: ""
                              }, [
                                _hoisted_37,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxRates.value, (tax) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: tax.id + 'tax',
                                    value: tax.id
                                  }, _toDisplayString(tax.value_as_percentage), 9, _hoisted_38))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, formFields.value.tax_rate_id]
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("button", {
          disabled: formSubmitting.value,
          type: "submit",
          class: "btn btn-text"
        }, [
          (formSubmitting.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _hoisted_42,
                _createVNode(BaseSpinner)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_43, "Update Unit"))
        ], 8, _hoisted_40)
      ]),
      (formErrors.value.non_field_errors !== undefined)
        ? (_openBlock(), _createBlock(_component_BaseAlert, {
            key: 1,
            variant: "danger",
            class: "js-form-error",
            dismissible: "",
            onDismissed: _cache[13] || (_cache[13] = ($event: any) => (formErrors.value = {}))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(formErrors.value.non_field_errors[0]), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 40, _hoisted_2)
  ], 64))
}
}

})